export default "__VITE_ASSET__B46gyvpx__"